<template>
  <div />
</template>
<script>
import "@/assets/libs/leaflet-wms-legend-master/leaflet.wmslegend";

export default {
  props: {
    active: {
      type: Boolean,
      required: true
    },
    config: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      legend: {},
      map: this.$parent.map,
      protocols: { HTTP: "HTTP", WMS: "WMS" }
    };
  },
  watch: {
    active() {
      if (this.active) {
        this.init();
      } else {
        this.removeLegend();
      }
    }
  },
  methods: {
    init() {
      switch (this.config.options.type) {
        case this.protocols.HTTP: {
          this.loadHTTPLegend();
          break;
        }
        case this.protocols.WMS: {
          this.loadWMSLegend();
          break;
        }
      }
    },
    loadWMSLegend() {
      const uri = this.getRequest();
      this.addLegend(uri);
    },
    getRequest() {
      return `${
        this.config.url
      }?SERVICE=WMS&VERSION=1.1.1&REQUEST=GetLegendGraphic&FORMAT=${
        this.config.options.format
      }&LAYER=${this.config.layerName}&TRANSPARENT=${
        this.config.options.transparent
      }`;
    },
    loadHTTPLegend() {
      this.addLegend(this.config.options.imageUrl);
    },
    addLegend(uri) {
      this.legend = new L.Control.WMSLegend({
        position: "bottomright",
        uri: uri
      });
      this.legend.addTo(this.map);
    },
    removeLegend() {
      if (Object.keys(this.legend).length > 0) {
        this.map.removeControl(this.legend);
      }
    }
  }
};
</script>
<style scoped></style>
